<template>
  <div :class="`m-portal .m-portal-${routeType}-nav ${currentModule}`">
    <div class="left-menu">
      <div class="menu-title">文化旅游</div>
      <div class="menu-items">
        <div v-if="['spot','spot_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a style="font-weight: bold;" @click="travel('destinations','spot')" class="waves">
            景区景点
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="travel('destinations','spot')" class="waves">
            景区景点
            <span>></span>
          </a>
        </div>
        <div
          v-if="['classics','classics_detail'].indexOf($route.params._field)>-1"
          class="menu-item"
        >
          <a
            style="font-weight: bold;"
            @click="handleRouteJXPage('routes','classics')"
            class="waves"
          >
            精选线路
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleRouteJXPage('routes','classics')" class="waves">
            精选线路
            <span>></span>
          </a>
        </div>
        <div v-if="['travel','travel_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a style="font-weight: bold;" @click="handleRoutePage('routes','travel')" class="waves">
            行程规划
            <span>></span>
          </a>
        </div>
        <!-- <div v-else class="menu-item">
          <a @click="handleRoutePage('routes','travel')" class="waves">
            行程规划
            <span>></span>
          </a>
        </div> -->
        <div v-if="['hotel','hotel_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a
            style="font-weight: bold;"
            @click="handleMercHotelPage('merchant','hotel')"
            class="waves"
          >
            酒店住宿
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleMercHotelPage('merchant','hotel')" class="waves">
            酒店住宿
            <span>></span>
          </a>
        </div>
        <div v-if="['ticket','ticket_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a
            style="font-weight: bold;"
            @click="handleMerdPage('merchandise','ticket')"
            class="waves"
          >
            门票信息
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleMerdPage('merchandise','ticket')" class="waves">
            门票信息
            <span>></span>
          </a>
        </div>
        <div v-if="['food','food_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a style="font-weight: bold;" @click="handleMercPage('merchant','food')" class="waves">
            餐饮美食
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleMercPage('merchant','food')" class="waves">
            餐饮美食
            <span>></span>
          </a>
        </div>
        <div v-if="['yjgl','yjgl_detail'].indexOf($route.params._field)>-1" class="menu-item">
          <a style="font-weight: bold;" @click="handleArtiPage('article','yjgl')" class="waves">
            游记攻略
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','yjgl')" class="waves">
            游记攻略
            <span>></span>
          </a>
        </div>
        <div v-if="['720'].indexOf($route.params._field)>-1" class="menu-item">
          <a style="font-weight: bold;" @click="handleArtiPage('article','720')" class="waves">
            全景浏览
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','720')" class="waves">
            全景浏览
            <span>></span>
          </a>
        </div>
        <div v-if="['vr'].indexOf($route.params._field)>-1" class="menu-item">
          <a style="font-weight: bold;" @click="handleArtiPage('article','vr')" class="waves">
            全景视频
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','vr')" class="waves">
            全景视频
            <span>></span>
          </a>
        </div>
        <div v-if="['3d'].indexOf($route.params._field)>-1" class="menu-item">
          <a style="font-weight: bold;" @click="handleArtiPage('article','3d')" class="waves">
            虚拟体验
            <span>></span>
          </a>
        </div>
        <div v-else class="menu-item">
          <a @click="handleArtiPage('article','3d')" class="waves">
            虚拟体验
            <span>></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require("../../styles/portal/travel.scss");
export default {
  data() {
    return {
      routeType: "dest",
      activeIndex: {}
    };
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  methods: {
    travel(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/dest/page/${moudle}/${field}`
      });
    },
    handleVideoList(moudle, field) {
      this.$router.push({
        path: `/portal/dest/list/${moudle}/${field}`
      });
    },
    handleMercPage(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      // this.$router.push({
      //   path: `/portal/merc/page/${moudle}/${field}`
      // });
       window.location.href = `/portal/merc/page/merchant/food`;
    },
    handleMercHotelPage(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      window.location.href = `/portal/merc/page/merchant/hotel`;
    },
    handleMerdPage(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/merd/page/${moudle}/${field}`
      });
    },
    handleRoutePage(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/route/page/${moudle}/${field}`
      });
    },
    handleRouteJXPage(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/route/page/${moudle}/${field}`
      });
    },
    handleArtiPage(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/arti/page/${moudle}/${field}`
      });
    },
    handleVideoDetail(moudle, field, item) {
      this.$router.push({
        path: `/portal/dest/detail/${moudle}/${field}/${item.destId}`
      });
    },
    handleArtiList(moudle, field) {
      this.$router.push({
        path: `/portal/arti/list/${moudle}/${field}`
      });
    },
    handleArtiDetail(moudle, field, item) {
      this.$router.push({
        path: `/portal/arti/detail/${moudle}/${field}/${item.artiId}`
      });
    }
  },
  created() {}
};
</script>

<style scoped>
</style>